import { render, staticRenderFns } from "./TimelessTenderRegulationsModal.vue?vue&type=template&id=6d82fe15&scoped=true"
import script from "./TimelessTenderRegulationsModal.vue?vue&type=script&lang=js"
export * from "./TimelessTenderRegulationsModal.vue?vue&type=script&lang=js"
import style0 from "./TimelessTenderRegulationsModal.vue?vue&type=style&index=0&id=6d82fe15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d82fe15",
  null
  
)

export default component.exports